module.exports = "/interactives/anyang/life-in-the-city/_next/static/images/background-daf02a24369c77674723252a84523bbb.png";